import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d3f61bb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row outcomes-row" }
const _hoisted_2 = {
  key: 0,
  class: "col-md-12 outcome-title"
}
const _hoisted_3 = { class: "outcome-title-text" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "outcome-image-container" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "col-md-12 text-center next-button-container" }
const _hoisted_9 = {
  key: 0,
  class: "btn btn-primary",
  "data-test": "pathway-next"
}

import { debug as d } from "debug";
import { onBeforeMount, provide, ref, computed } from "vue";
import { useRoute } from "vue-router";
import {
  CmsDocumentTypes,
  CmsGoalData,
  CmsPathwaysRelationship,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import { csContext } from "../../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-pathway',
  props: {
    isTeamLeaderOrOrgAdmin: { type: Boolean }
  },
  emits: ["hide-stepper", "update-stepper"],
  setup(__props: any, { emit: __emit }) {

const debug = d;

const props = __props;

const route = useRoute();
const origin = computed(() => route.query.origin as string);

const pathwayUid = ref("");
const outcomeUid = ref("");
const outcome = ref<CmsGoalData | null>(null);
const teamId = ref("");
const isNextButtonDisplayed = ref(false);
const orgId = ref(csContext.user?.organisation?.id ?? "");

function displayNextButton(uid: string): void {
  pathwayUid.value = uid;
  isNextButtonDisplayed.value = props.isTeamLeaderOrOrgAdmin || route.query.asaccredited === 'true';
}

const emit = __emit;

function hideStepper(): void {
  emit("hide-stepper");
}

const pathways = ref<CmsPathwaysRelationship[]>([]);
provide("teamPathways", pathways);

onBeforeMount(async () => {
  debug("response");
  outcomeUid.value = route.params.outcomeUid as string;
  const response = await cms.getByUid(CmsDocumentTypes.CmsTeamGoal, outcomeUid.value);
  console.log('CMS Response:', response);
  outcome.value = response.data;
  console.log('Outcome data:', outcome.value);
  pathways.value = outcome.value.pathways;
  console.log('Pathways:', pathways.value);
  emit("update-stepper", route.name);
  
  // Ensure we have valid teamId and orgId
  if (!route.params.id) {
    console.error('Team ID is missing from route params');
    return;
  }
  teamId.value = route.params.id as string;
  
  if (!csContext.user?.organisation?.id) {
    console.error('Organization ID is missing from user context');
    return;
  }
  orgId.value = csContext.user.organisation.id;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      (outcome.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "outcome-title-header",
                innerHTML: _unref(cms).asHtml(outcome.value.full_title),
                "data-test": "pathway-outcome-title"
              }, null, 8, _hoisted_4),
              _createElementVNode("p", {
                class: "outcome-title-desc",
                innerHTML: _unref(cms).asHtml(outcome.value.brief_description),
                "data-test": "pathway-outcome-desc"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                src: outcome.value.image.url,
                alt: _unref(cms).asText(outcome.value.name),
                class: "outcome-image",
                "data-test": "pathway-outcome-img"
              }, null, 8, _hoisted_7)
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view, {
        onDisplayNextButton: displayNextButton,
        onHideStepper: hideStepper,
        isTeamLeaderOrOrgAdmin: _ctx.isTeamLeaderOrOrgAdmin,
        teamId: teamId.value,
        orgId: orgId.value,
        ref: "view"
      }, null, 8, ["isTeamLeaderOrOrgAdmin", "teamId", "orgId"]),
      _createElementVNode("div", _hoisted_8, [
        (isNextButtonDisplayed.value && pathwayUid.value.length > 0)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: `pathway/${pathwayUid.value}${_unref(route).query.asaccredited ? `?asaccredited=${_unref(route).query.asaccredited}` : ''}`
            }, {
              default: _withCtx(() => [
                (isNextButtonDisplayed.value)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_9, " Next "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})